var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAdversMediaV01Orange = function SvgAdversMediaV01Orange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#advers-media-V01-orange_svg__a)",
    d: "M14 26.21a2 2 0 0 1 2.199-1.99l16 1.6A2 2 0 0 1 34 27.81v25.98a2 2 0 0 1-2.199 1.99l-16-1.6A2 2 0 0 1 14 52.19V26.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8 10 32 4v56L8 66V10ZM72 10l-32 4v56l32-4V10Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m48 37 16-2M48 29l8-1M48 45l16-2M48 53l16-2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "advers-media-V01-orange_svg__a",
    x1: 34.244,
    x2: 13.989,
    y1: 39.505,
    y2: 39.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5BE60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BE60",
    stopOpacity: 0.2
  })))));
};
export default SvgAdversMediaV01Orange;